import SEO from '../components/SEO/SEO';
import MobileNav from '../components/Navigations/mobileNav';
import Nav from '../components/Navigations/desktopNav';
import type { Swiper as SwiperType } from 'swiper';
import { useState } from 'react';
import Footer from '../components/Footer/footer';
import ProductGallery from '../layout/client-side/installations/product-gallery';
import Header from '../layout/client-side/installations/product-intro-detail';
import CTA from '../components/CTA/call-to-action';
import ProductInfo from '../layout/client-side/installations/product-info';

const InstallationDetails = () => {
  const [swiper] = useState<SwiperType | null>(null);

  return (
    <>
      <SEO
        title="AirSolutions Belgium - Uw partner voor airconditioning en koeltechniek"
        description="Ontdek AirSolutions Belgium, uw betrouwbare partner voor airconditioning en koeltechniek. Wij bieden op maat gemaakte oplossingen voor residentiële en commerciële toepassingen."
        keywords="AirSolutions, airconditioning, koeltechniek, HVAC, residentieel, commercieel"
        canonical="/catalogus-details"
      />
      <MobileNav />
      <Nav swiper={swiper} />
      <Header />
      <ProductGallery />
      <ProductInfo />
      <CTA />
      <Footer />
    </>
  );
};

export default InstallationDetails;
